module.exports = "/virtual-football-league/img/amblems/left/logos/Vil.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Vil.png
// module id = 2130
// module chunks = 4